import { render, staticRenderFns } from "./Barometer.vue?vue&type=template&id=3ba4b0d1&scoped=true"
import script from "./Barometer.vue?vue&type=script&lang=js"
export * from "./Barometer.vue?vue&type=script&lang=js"
import style0 from "./Barometer.vue?vue&type=style&index=0&id=3ba4b0d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4b0d1",
  null
  
)

export default component.exports